import React from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { SET_SELECTED_DETAIL_OUTPUT } from '../SettingsReducer.js'

const DummyOutput = ({
  accessor,
  info: {
    Enabled = false,
    enabled = false,
    IsEnabled = false,
    DisplayName = '',
    label = '',
    Label = '',
    CardNumber = 0,
    Column = 0,
    FieldType,
  },
  outputFormat = '???',
  isHistory = false,
  isGeneric = false,
}) => {
  const dispatch = useDispatch()
  const {
    selectedDetailOutput: { accessor: selectedAccessor },
  } = useSelector((state) => state.settings.recordDetailConfig, shallowEqual)

  return (
    <div
      className={`dummy-i-bar-item ${!(Enabled || enabled || IsEnabled) ? 'disabled' : ''} ${
        isHistory ? 'history' : ''
      } row`}
      onClick={() => {
        dispatch({
          type: SET_SELECTED_DETAIL_OUTPUT,
          accessor,
          info: {
            Enabled,
            enabled,
            IsEnabled,
            DisplayName,
            FieldType,
            label,
            Label,
            CardNumber,
            Column,
          },
          isHistory,
          drawerShown: true,
          isGeneric,
        })
      }}
    >
      <div className={`label ${selectedAccessor === accessor ? 'selected' : ''}`}>
        {DisplayName || label || Label || 'Label Not Set'}
        {`: `}
      </div>
      <div
        className={`value ${selectedAccessor === accessor ? 'selected' : ''}`}
      >{` ${outputFormat}`}</div>
    </div>
  )
}

export default DummyOutput
